import { useDispatch } from 'react-redux';
import moment from 'moment';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import NsContent from 'components/common/ns-content/NsContent';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { setMoveInDate } from 'state/move-in-date/move-in-date-slice';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsDatepicker } from 'components/common/ns-datepicker/NsDatepicker';
import { DATE_FORMAT } from 'config/app-config';
import { useNavigation } from 'hooks/useNavigation';
import { useMoveInDate } from 'components/direct-sales/move-in-date/hooks/useMoveInDate';
import { useHandleMoveInVerifyError } from 'components/direct-sales/move-in-date/hooks/useHandleMoveInVerifyError';
import { moveInDateVerifyThunk } from 'state/move-in-date/move-in-date-thunk';
import { Error } from 'components/common/error/Error';
import { hasIneligibleError } from 'hooks/useIsMoveInEligible';

export const testId = 'homeMoveDateTestId';

export const MoveInDate = () => {
  const dispatch = useDispatch();
  const { next, eventTypes } = useNavigation();

  const {
    selectedMoveInDate,
    maximumMoveInDate,
    minimumMoveInDate,
    isLoading,
    udprn,
    errors,
    hasMoveInPreSSDError
  } = useMoveInDate();

  const selectedMoveInDateValue =
    selectedMoveInDate &&
    moment(selectedMoveInDate, DATE_FORMAT, true).format(DATE_FORMAT);

  const handleMoveInVerifyError = useHandleMoveInVerifyError();

  const handleGoNext = async () => {
    try {
      await dispatch(
        moveInDateVerifyThunk({
          udprn,
          moveInDate: moment(selectedMoveInDate, DATE_FORMAT, true)
            .utc(true)
            .format()
        })
      );
      next({ eventType: eventTypes.NEXT });
    } catch (error) {
      const e = handleMoveInVerifyError(error);

      if (hasIneligibleError(e)) {
        next({ eventType: eventTypes.NEXT });
      }

      e && console.error(e);
    }
  };

  const handleChange = async (event) => {
    const {
      target: { processedValue }
    } = event;
    const mProcessedValue = moment(processedValue, DATE_FORMAT, true);
    mProcessedValue.isValid() && dispatch(setMoveInDate(processedValue));
  };

  return (
    <div data-testid={testId}>
      <NsPanel>
        <NsBackCta />
        <NsContent>
          <NsTitle title="When did you pick up the keys?" />
          <p>
            Please note that you can only choose today&apos;s date, or a date in
            the past. If you haven&apos;t moved in yet, please come back once
            you have. Don&apos;t forget to take your meter readings on your
            moving day.
          </p>
        </NsContent>
        <NsForm onSubmit={handleGoNext}>
          {!hasMoveInPreSSDError && (
            <NsDatepicker
              name="moveInDate"
              label="Key pick-up date"
              value={selectedMoveInDateValue ?? ''}
              min={minimumMoveInDate}
              max={maximumMoveInDate}
              onChange={handleChange}
            />
          )}
          <Error errors={errors} />
          <NsPrimaryCta isLoading={isLoading}>Continue</NsPrimaryCta>
        </NsForm>
      </NsPanel>
    </div>
  );
};

export default MoveInDate;
